define('shared/remote/offer/get',[
    '$',
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/page/language',
    'shared/page/market',
    'shared/page/partner',
    'shared/remote/member/get',
    'shared/initializer/form/constants',
    'shared/lib/console',
    'shared/util/checkout/checkout',
    'shared/page/apiVersion',
    'shared/remote/ajax'
],
function ($, RSVP, state, getLanguage, getMarket, getPartner, getMember,
    constants, console, checkoutUtil, getAPIVersion, ajax) {
    'use strict';
    
    // marketCode=us&partnerCode=None&cultureCode=en&studentType=NeverStudent&offerType=Subscription&svc_debug=true
    var URL_BASE = '/services/commerce-v4/offermanager/';
    var NEW_HOUSE_URL = '/1/api/commerce-gateway/offer/';
    var ACTION_FIND = 'find';
    var ACTION_GET = 'get';
    var ACTION_GET_BY_COUPON = 'getoffersbycoupon';
    var ACTION_GET_BY_Redemption = 'GetOfferByRedemption';
    var cache = {};

    function getByContext( market, language, partner, studentType, offerType) {
        return new RSVP.Promise(function(resolve, reject){
            var dfd = $.ajax({
                url: URL_BASE + ACTION_FIND,
                type: 'POST',
                data: {
                    marketCode: market,
                    cultureCode: language + '-' + market,
                    partnerCode: partner,
                    studentType: studentType,
                    offerType: offerType
                },
                dataType: 'json'
            });
            dfd.then( resolve, reject );
        });
    }

    function getByCoupon(couponCode) {
        return RSVP.resolve()
            .then(function(){
                return RSVP.all([getMarket(), getLanguage(), getPartner(), getMember()]);
            })
            .then(function(environment){
                var market = environment[0];
                var languageCode = environment[1];
                var partner = environment[2];
                var studentType = constants.StudentType.NeverStudent;
                var member = environment[3];
                if(member && member.StudentType){
                    studentType = member.StudentType;
                }
                var paymentType = constants.PaymentType.CreditCard;

                return new RSVP.Promise(function(resolve, reject){
                    var dfd = $.ajax({
                        url: URL_BASE + ACTION_GET_BY_COUPON,
                        type: 'POST',
                        dataType: 'json',
                        data: {
                            couponCode: couponCode,
                            marketCode: market,
                            partnerCode: partner,
                            cultureCode: languageCode + '-' + market,
                            paymentType: paymentType,
                            studentType: studentType
                        }
                    });
                    dfd.then( resolve, reject );
                });
            });
    }

    function getByRedemption(rCode) {
        return RSVP.resolve()
            .then(function(){
                return RSVP.all([getMarket(), getLanguage(), getPartner(), getMember()]);
            })
            .then(function(environment){
                var market = environment[0];
                var languageCode = environment[1];
                var partner = environment[2];
                var studentType = constants.StudentType.NeverStudent;
                var member = environment[3];
                if(member && member.StudentType){
                    studentType = member.StudentType;
                }

                return new RSVP.Promise(function(resolve, reject){
                    var dfd = $.ajax({
                        url: URL_BASE + ACTION_GET_BY_Redemption,
                        type: 'POST',
                        dataType: 'json',
                        data: {
                            redemptionCode: rCode,
                            marketCode: market,
                            partnerCode: partner,
                            cultureCode: languageCode + '-' + market,
                            studentType: studentType
                        }
                    });
                    dfd.then( resolve, reject );
                });
            });
    }

    function getByIdInOldHouse(id) {
        return RSVP.resolve()
            .then(function(){
                return RSVP.all([getMarket(), getLanguage()]);
            })
            .then(function(values){
                var market = values[0], language = values[1];
                return new RSVP.Promise(function(resolve, reject){
                    var dfd = $.ajax({
                        url: URL_BASE + ACTION_GET + '/' + id,
                        type: 'GET',
                        dataType: 'json',
                        data: {
                            cultureCode: language + '-' + market
                        }
                    });
                    dfd.then( resolve, reject );
                });
            });
    }

    function getByIdInNewHouse(id) {
        return RSVP.resolve()
            .then(function(){
                return ajax({
                    url: NEW_HOUSE_URL + '/' + id,
                    method: 'get'
                });
            });
    }

    function getById() {
        var me = this;
        var args = Array.prototype.slice.apply(arguments);
        return getAPIVersion()
            .then(function(apiVersion){
                if (apiVersion === 'new-house') {
                    return getByIdInNewHouse.apply(me, args);
                }
                else {
                    return getByIdInOldHouse.apply(me, args);
                }
            });
    }

    return function( options ){
        var promise, data;

        if ( options != null && options.id != null ) {
            promise = RSVP.resolve()
                .then(function(){
                    if ( cache[options.id] != null ) {
                        return RSVP.resolve(cache[options.id]);
                    }
                    else {
                        return getById( options.id );
                    }
                });
        }
        else if (options && options.redemptionCode){
            return getByRedemption(options.redemptionCode).then(function(data){
                if ( data['Success'] !== true ) {
                    return RSVP.reject('Server failed to process redemption code ' + options.redemptionCode);
                }

                if(data['Result']){
                    return data['Result'];
                }
                else{
                    console.warn('Cannot get offer by redemptionCode: ' + options.redemptionCode + ' ');
                    return null;
                }
            });
        }
        else if (options && options.couponCode){
            return getByCoupon(options.couponCode).then(function(data){
                if ( data['Success'] !== true ) {
                    return RSVP.reject('Server failed to process coupon code ' + options.couponCode);
                }

                if(data['Result'] && data['Result'].length > 0){
                    return data['Result'][0];
                }
                else{
                    console.warn('Cannot get offers by CouponCode: ' + options.couponCode + ' ');
                    return null;
                }
                });
        }
        else {
            var offerType = constants.OfferType.Subscription;
            var flowType;
            var studentType = constants.StudentType.NeverStudent;

            promise = RSVP.resolve()
                .then(function(){
                    return checkoutUtil.getCurrentFlowType();
                })
                .then(function(type){
                    flowType = type;
                })
                .then(function(){
                    if(options && options.offerType){
                        offerType = options.offerType;
                    }
                    else{
                        if(flowType === constants.CheckoutFlowType.Upsell){
                            offerType = constants.OfferType.Upsell;
                        }
                    }
                })
                .then(function(){
                    return getMember().then(function(member){
                        if(member && member.StudentType){
                            studentType = member.StudentType;
                        }

                        return RSVP.resolve();
                    });
                })
                .then(function(){
                    return RSVP.all([getMarket(), getLanguage(), getPartner()]);
                })
                .then(function(values){
                    values.push(studentType);
                    values.push(offerType);
                    return getByContext.apply(this, values);
                });
        }

        return promise
            .then(function(value) {
                data = value;
                return getAPIVersion();
            })
            .then(function(apiVersion){
                if (apiVersion === 'new-house') {
                    return data;
                }
                else {
                    if (data['Success'] !== true) {
                        return RSVP.reject('Server failed to return current offer');
                    }

                    cache[data.Result.Id] = data;

                    return data['Result'];
                }
            });
    };
});
